/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {familyAccountsLockIssuedCards} from '../api'

export const useMutationFamilyAccountsLockIssuedCards = createReactQueryMutationHook('familyAccountsLockIssuedCards', familyAccountsLockIssuedCards)
